export default __webpack_public_path__ + "static/media/logo-mark.a6d2b1d4.png";